import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Header, InputMui } from '../../../../../../components';
import { useTariffConfigurationContext } from '../../context/tariff-configuration-context';

const TariffPrices: React.FC = () => {
  const { t } = useTranslation('channel-details');
  const { t: tc } = useTranslation('common');
  const { t: tnf } = useTranslation('configuration');
  const {
    form,
    formValues: { prices },
  } = useTariffConfigurationContext();

  return (
    <>
      <Header title={t('price')} subtitle={tnf('tariffPricesInfo')} column />
      <div className="grid-list-24">
        {prices.map((p, i) => {
          const label =
            prices.length > 1
              ? `${t(
                  `energyMeasurements.subLabel.FORWARD_ACTIVE_ENERGY_PERIOD${p.pricingTier}${
                    prices.length === 2 ? '_OF_2' : ''
                  }`,
                )} (zł/kWh)`
              : t('price');

          return (
            <Controller
              key={`price-${i}`}
              name={`prices.${i}.price`}
              control={form.control}
              rules={{ required: tc('isRequired') as string }}
              render={({ field, fieldState: { error } }) => (
                <InputMui
                  label={label}
                  placeholder="0 zł"
                  type="number"
                  name={field.name}
                  onChange={field.onChange}
                  value={field.value?.toString()}
                  step={0.01}
                  {...(error && { errorMessage: error.message })}
                />
              )}
            />
          );
        })}
      </div>
    </>
  );
};

export default TariffPrices;
